import { createReducer, on } from '@ngrx/store';

import * as Client from '@vi-iot/client';
import { RemoteConfigActions } from '../remote-config';

import { AuthActions } from './auth.actions';
import { AuthState } from './auth.state';

export const initAuthState: AuthState = {
  me: null,
  authenticating: false,
  authenticated: false,
  authorizing: false,
  authorized: false,
  authorizedAs: {},
  demo: false,
  learningRoom: true,
  eventBanner: true,
  paidFeaturesBanner: true,
  availableCompanyPaidFeatures: [],
  companySubscriptionPlan: null,
  connectivityRanking: null,
  company: {
    error: null,
    loading: false,
    value: null,
  },
};

/* eslint-disable */
export const authReducer = createReducer(
  initAuthState,
  on(AuthActions.startAuthFlow, (): AuthState => ({ ...initAuthState, authenticating: true })),

  on(
    AuthActions.showLandingPage,
    (): AuthState => ({
      ...initAuthState,
      authenticating: false,
      authenticated: false,
      authorized: false,
      authorizing: false,
    })
  ),

  on(
    AuthActions.getMe.attempt,
    (state): AuthState => ({
      ...state,
      authenticating: false,
      authenticated: true,
      authorizing: true,
      authorized: false,
    })
  ),

  on(
    AuthActions.getMe.success,
    (state, { me }): AuthState => ({
      ...state,
      me,
    })
  ),

  on(AuthActions.navigateToForbiddenPage, (state): AuthState => ({ ...state, authorizing: false })),

  on(
    AuthActions.authorizeMe,
    (state, { roleGroup }): AuthState => ({
      ...state,
      authorizing: false,
      authorized: true,
      authorizedAs: {
        user: roleGroup === Client.RoleGroupType.User,
        maintainer: roleGroup === Client.RoleGroupType.Maintainer,
        supportLocal:
          roleGroup === Client.RoleGroupType.SupportLocal ||
          roleGroup === Client.RoleGroupType.SupportLocalReadWriteWithRemoteDiagnosis ||
          roleGroup === Client.RoleGroupType.SupportLocalDepartmentManagement,
        supportInternational:
          roleGroup === Client.RoleGroupType.SupportInternational ||
          roleGroup === Client.RoleGroupType.SupportInternationalWithRemoteDiagnosis,
        admin: roleGroup === Client.RoleGroupType.Admin,
      },
    })
  ),

  on(
    AuthActions.updateEmail,
    (state, { email }): AuthState => ({
      ...state,
      me: {
        ...state.me,
        contacts: {
          ...state.me.contacts,
          email,
        },
      },
    })
  ),

  on(
    AuthActions.updatePhone,
    (state, { phone }): AuthState => ({
      ...state,
      me: {
        ...state.me,
        contacts: {
          ...state.me.contacts,
          telephone: phone,
          mobile: phone,
        },
      },
    })
  ),

  on(AuthActions.logout, AuthActions.exitDemo, (): AuthState => ({ ...initAuthState })),

  on(AuthActions.runDemo, (state): AuthState => ({ ...state, demo: true })),

  on(
    AuthActions.eventBanner.closeSuccess,
    (state): AuthState => ({ ...state, eventBanner: false })
  ),

  on(
    AuthActions.eventBanner.showSuccess,
    (state, { isActive }): AuthState => ({
      ...state,
      eventBanner: isActive,
    })
  ),

  on(
    AuthActions.paidFeaturesBanner.closeSuccess,
    (state): AuthState => ({ ...state, paidFeaturesBanner: false })
  ),

  on(
    AuthActions.paidFeaturesBanner.showSuccess,
    (state, { isActive }): AuthState => ({ ...state, paidFeaturesBanner: isActive })
  ),

  on(
    AuthActions.learningRoomBanner.showSuccess,
    (state, { isActive }): AuthState => ({
      ...state,
      learningRoom: isActive,
    })
  ),

  on(
    AuthActions.learningRoomBanner.closeSuccess,
    (state): AuthState => ({ ...state, learningRoom: false })
  ),

  on(
    RemoteConfigActions.getRemoteConfigError,
    (state): AuthState => ({
      ...state,
      authenticating: false,
      authorizing: false,
    })
  ),

  on(
    AuthActions.readCompanyPaidFeatures.success,
    (state, { subscriptionWithPaidFeatures }): AuthState => ({
      ...state,
      availableCompanyPaidFeatures: subscriptionWithPaidFeatures?.features || [],
      companySubscriptionPlan: subscriptionWithPaidFeatures?.plan,
    })
  ),

  on(
    AuthActions.readCompanyPaidFeatures.error,
    (state): AuthState => ({
      ...state,
    })
  ),

  on(
    AuthActions.getConnectivityRanking.success,
    (state, { connectivityRanking }): AuthState => ({
      ...state,
      connectivityRanking,
    })
  ),

  on(
    AuthActions.getUserCompany.attempt,
    (state): AuthState => ({
      ...state,
      company: {
        error: null,
        loading: true,
        value: null,
      },
    })
  ),

  on(
    AuthActions.getUserCompany.success,
    (state, { data }): AuthState => ({
      ...state,
      company: {
        error: null,
        loading: false,
        value: data,
      },
    })
  ),

  on(
    AuthActions.getUserCompany.error,
    (state, { error }): AuthState => ({
      ...state,
      company: {
        error,
        loading: false,
        value: null,
      },
    })
  )
);
